import React from 'react';
import { isContentFragment } from '../../content-types';
const AUTHOR_MODE = 1;
export const UniversalEditorContext = React.createContext({
    isAuthorMode: false,
    isFalconContent: false,
});
const noopSubscribe = () => () => undefined;
const getServerSnapshot = () => false;
function isValidContent(content, isAuthorMode) {
    if ((content === null || content === void 0 ? void 0 : content.__type) === 'aem-headless' && isContentFragment(content)) {
        return true;
    }
    if (isAuthorMode) {
        console.warn('The content provided to <UniversalEditorProvider /> is not valid Falcon content', content);
    }
    return false;
}
export const UniversalEditorProvider = ({ contentService, renderModeService, children }) => {
    const [rawContent, setRawContent] = React.useState(contentService.getContent());
    const getAuthorMode = React.useCallback(() => (renderModeService === null || renderModeService === void 0 ? void 0 : renderModeService.getRenderMode()) === AUTHOR_MODE, [renderModeService]);
    const isAuthorMode = React.useSyncExternalStore(noopSubscribe, getAuthorMode, getServerSnapshot);
    const [isFalconContent, setIsFalconContent] = React.useState(isValidContent(rawContent, isAuthorMode));
    React.useEffect(() => {
        const listener = () => {
            const newContent = contentService.getContent();
            setRawContent(newContent);
            setIsFalconContent(isValidContent(rawContent, isAuthorMode));
        };
        contentService.onContentChange(listener);
        return () => {
            contentService.removeOnContentChange(listener);
        };
    }, [contentService, setRawContent]);
    const ueContext = React.useMemo(() => ({
        isAuthorMode,
        isFalconContent,
        rawCmsContent: rawContent,
    }), [isAuthorMode, isFalconContent, rawContent]);
    return (React.createElement(UniversalEditorContext.Provider, { value: ueContext }, children));
};
//# sourceMappingURL=universal-editor-context.js.map